import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Eye, EyeOff, User, Lock } from 'lucide-react';
import Logo from './Logo';
import './Login.css';
import { apiRequest } from '../config/api';

export default function InfluencerLogin() {
  const [influencerCode, setInfluencerCode] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      // Login real del influencer
      const data = await apiRequest('/api/influencers/login', {
        method: 'POST',
        body: {
          influencerCode: influencerCode,
          password: password
        }
      });

      if (data.success) {
        // Guardar sesión del influencer
        localStorage.setItem('influencerSession', JSON.stringify(data.influencer));
        navigate('/influencer/dashboard');
      } else {
        setError('Código de influencer o contraseña incorrectos');
      }
    } catch (error) {
      console.error('Error en login:', error);
      setError('Error al iniciar sesión');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <Logo size="auth-logo" className="auth-logo" />
          <h2>Login de Influencer</h2>
          <p>Accede a tu dashboard de influencer</p>
        </div>

        <form onSubmit={handleSubmit} className="auth-form">
          {error && (
            <div className="error-banner">
              {error}
            </div>
          )}

          <div className="form-group">
            <label htmlFor="influencerCode">Código de Influencer</label>
            <div className="input-wrapper">
              <User size={20} className="input-icon" />
              <input
                id="influencerCode"
                type="text"
                className="input"
                value={influencerCode}
                onChange={(e) => setInfluencerCode(e.target.value.toUpperCase())}
                placeholder="Tu código de influencer"
                required
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="password">Contraseña</label>
            <div className="input-wrapper">
              <Lock size={20} className="input-icon" />
              <input
                id="password"
                type={showPassword ? 'text' : 'password'}
                className="input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Tu contraseña"
                required
              />
              <button
                type="button"
                className="password-toggle"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
              </button>
            </div>
          </div>

          <button
            type="submit"
            className="btn btn-primary auth-button"
            disabled={loading}
          >
            {loading ? 'Iniciando sesión...' : 'Iniciar Sesión'}
          </button>
        </form>

        <div className="auth-footer">
          <p>
            ¿No eres influencer?{' '}
            <a href="/login" className="auth-link">
              Login normal
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}
